import Service from "@/services/Service";
const resource = "hmnhierarchicallevel/";
export default {
    save(adc, requestID) {
        return Service.post(resource + "save", adc, {
            params: { requestID: requestID },
        });
    }
    ,
    pagination(dtr, requestID) {
        return Service.post(resource + "pagination", dtr, {
            params: { requestID: requestID },
        });
    },
    list(requestID) {
        return Service.post(resource + "list", {}, {
            params: { requestID: requestID },
        });
    }
};